import React from "react";
import styles from "./sobre_mim_tayfrassontattoo.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Sobre_mim_tayfrassontattoo: React.FC = () => {

    return (
        <div className={styles.sobre_mim_tayfrassontattoo}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/tayfrassontattoo" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img src={require("./src/img_sobremim.png")} alt="Tayná Frasson" />
                </div>
                <h2>Tayná Frasson</h2>
                <p>
                    Com mais de 6 anos de experiência, sou tatuadora apaixonada pela arte de transformar sentimentos em histórias na pele. Ao longo da minha trajetória, fui premiada mais de 25 vezes em eventos de tatuagem, reconhecimento que fortalece ainda mais meu compromisso com qualidade e inovação.
                </p>
                <p>
                   Sou especialista em fineline, técnica que exige precisão, delicadeza e sensibilidade. Além disso, desenvolvo trabalhos nos estilos ornamental, preto e cinza, pontilhismo, botânico, mini realismo pet, sticker, bordado e glitter, sempre respeitando a essência e a individualidade de cada cliente.
                </p>
                <p>
                   Minha missão vai além da tatuagem: busco elevar a autoestima de quem confia no meu trabalho, criando não apenas desenhos, mas experiências únicas. Estou em constante busca por atualização e aperfeiçoamento, para oferecer sempre o que há de melhor em qualidade, técnica e criatividade.
                </p>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>


                    <a href="https://wa.me/5518997958605?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/NnYiDFBX8zqoTtnR7" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/tayfrasson.tattoo?igsh=OWhtbGxhZDI0NzZ5" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_tayfrassontattoo;
